import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';

export const RovoActivationFragment: GraphQLTaggedNode = graphql`
	fragment RovoActivationFragment_query on Query @argumentDefinitions(cloudId: { type: "ID!" }) {
		tenantContexts(cloudIds: [$cloudId]) {
			activationIdByProduct(product: "rovo") {
				active
			}
		}
	}
`;
